import React from 'react';
import type { ReactNode } from 'react';

export interface Props {
  children?: ReactNode;
}

export const DefaultLayout: React.FC<Props> = (props) => {
  const { children } = props;

  return <div>{children}</div>;
};
